import { render, staticRenderFns } from "./ClipboardPreview.vue?vue&type=template&id=315f00a7&scoped=true"
import script from "./ClipboardPreview.vue?vue&type=script&lang=js"
export * from "./ClipboardPreview.vue?vue&type=script&lang=js"
import style0 from "./ClipboardPreview.vue?vue&type=style&index=0&id=315f00a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315f00a7",
  null
  
)

export default component.exports